import {
  ROOT,
  GET_ALL_LOCATION,
  GET_ALL_HOTEL_TYPE,
  GET_IMAGE_RESOURCE,
  GET_ALL_HOTEL_AMENITY,
  GET_ALL_OTA,
  GET_AREA_CODE,
  GET_ALL_HOTEL_SEGMENT,
  GET_ALL_OTA_GROUP,
  GET_MODULE_ACCESS
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";
// const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
// const authHeader = currentUser.token
//   ? { Authorization: "Token " + currentUser.token }
//   : {};

function getImagesResource(params) {
  let currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  let authHeader = currentUser.token ? { Authorization: "Token " + currentUser.token } : {};
  return fetch(
    ROOT +
    GET_IMAGE_RESOURCE +
    `?limit=${params.limit}&offset=${params.offset}`,
    {
      method: "GET",
      headers: {
        Authorization: authHeader.Authorization
      }
    }
  )
    .then(handleResponse)
    .then(data => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      return data;
    });
}
function getLocations() {
  return fetch(ROOT + GET_ALL_LOCATION, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getHotelTypes() {
  return fetch(ROOT + GET_ALL_HOTEL_TYPE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllHotelAmenity() {
  return fetch(ROOT + GET_ALL_HOTEL_AMENITY, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAllOta() {
  return fetch(ROOT + GET_ALL_OTA, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getAreaCode() {
  return fetch(ROOT + GET_AREA_CODE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllSegment() {
  return fetch(ROOT + GET_ALL_HOTEL_SEGMENT, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getOtaGroup() {
  return fetch(ROOT + GET_ALL_OTA_GROUP, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getModuleAccess() {
  return fetch(ROOT + GET_MODULE_ACCESS, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
export const systemService = {
  getModuleAccess,
  getOtaGroup,
  getAllSegment,
  getLocations,
  getHotelTypes,
  getImagesResource,
  getAllHotelAmenity,
  getAllOta,
  getAreaCode
};
